var {Platform} = require('react-native');

var Fabric = require('./wrappers/react-native-fabric');
var { Answers, Crashlytics } = Fabric;

var AnalyticsManager =
{
  initialize: function(appManager)
  {
    var thisThing = this;
    this.getDateForKey('FirstLaunch', appManager, function(date)
    {
      if (date == null)
      {
        thisThing.setDateForKey('FirstLaunch', appManager, function(){});
      }
    });
    // FOR FUTURE CASES
    // thisThing.setDateForKey('currentLaunch', appManager, function(){})
  },

  _datePrefix: 'analyticsTimeFor',

  getDateForKey: function(key, appManager, completion)
  {
    appManager.getVariable(this._datePrefix + key, completion)
  },

  setDateForKey: function(key, appManager, completion)
  {
    var date = Math.round(((new Date()).getTime()) / 1000);
    appManager.setVariable(this._datePrefix + key, date, function(){completion(date)})

    return date;
  },

  logFeature: function(title, name)
  {
    if( title.indexOf("Astart") == 0 ) title = "Feed"; // hack for feed title
    Answers.logContentView(title, 'feature', name);
  },

  logSignUpEvent: function(appManager, method, boolean, additionalParams)
  {
    var thisThing = this;
    var keyString = 'CreateUser' + (boolean ? 'True' : 'False');
    this.setDateForKey(keyString, appManager, function()
    {
      thisThing.getDateForKey(keyString, appManager, function(date)
      {
        var createUserDate = date;
        thisThing.getDateForKey('FirstLaunch', appManager, function(date)
        {
          var timeSinceFirstLaunch = createUserDate - date;
          var params = {'Since Launch Interval': thisThing.customAttributeKeyForTime(timeSinceFirstLaunch)};
          if( typeof additionalParams !== 'undefined' ) for( var key in additionalParams ) params[key] = additionalParams[key];

          Answers.logSignUp(method, boolean, params);
        });
      });
    });
  },

  logLoginEvent: function(appManager, type, boolean)
  {
    var thisThing = this;
    var keyString = 'Login' + (boolean ? 'True' : 'False');
    this.setDateForKey(keyString, appManager, function(loginDate)
    {
      thisThing.getDateForKey('FirstLaunch', appManager, function(date)
      {
        // console.log('LogLogin', 'FirstLaunch', date);
        var timeSinceFirstLaunch = loginDate - date;
        thisThing.getDateForKey('CreateUserTrue', appManager, function(date)
        {
          // console.log('CreateUserTrue', date);
          var timeSinceCreateUser = loginDate - date;
          Answers.logLogin(type.toUpperCase(), boolean,
          {
            'Since Launch Interval': thisThing.customAttributeKeyForTime(timeSinceFirstLaunch),
            'Since Sign Up Interval': thisThing.customAttributeKeyForTime(timeSinceCreateUser),
          });
        });
      });
    });
  },

  logCustomEvent: function(type, attributes)
  {
    Answers.logCustom(type, attributes);
  },

  customAttributeKeyForTime: function(timeSeconds)
  {
    var maxTime = 5 * 60; // 5 minutes
    if( timeSeconds >= maxTime ) return 'Greater than 5 minutes';

    var increments = 20;
    var i = 0;
    for( i = 0; (i*increments) <= timeSeconds; i++ );

    var startSeconds = (i-1) * increments;
    var endSeconds = i * increments;

    return 'Between ' + startSeconds + ' and ' + endSeconds + ' seconds';
  },

  logPurchaseEvent: function(appManager, itemPrice, boolean)
  {
    var thisThing = this;
    var keyString = 'FirstAddCredit' + (boolean ? 'True' : 'False');
    this.getDateForKey(keyString, appManager, function(date)
    {
      if (date == null)
      {
        var addCreditDate = thisThing.setDateForKey(keyString, appManager, function(){});

        thisThing.getDateForKey('FirstLaunch', appManager, function(date)
        {
          var timeSinceFirstLaunch = addCreditDate - date;
          thisThing.getDateForKey('LoginTrue', appManager, function(date)
          {
            var timeSinceLogin = addCreditDate - date;
            Answers.logPurchase(itemPrice, 'CAD', boolean, 'FirstAddCredit', 'FirstAddCredit', '',
            {
              'Since Launch Interval': thisThing.customAttributeKeyForTime(timeSinceFirstLaunch),
              'Since First Login Interval': thisThing.customAttributeKeyForTime(timeSinceLogin),
            });
          });
        });
      }
      else
      {
        Answers.logPurchase(itemPrice, 'CAD', boolean, 'AddCredit', 'AddCredit', '', {});
      }
    });
  },

  logException: function(text)
  {
    try {
      console.log(text);
      if( Platform.OS === 'ios') Crashlytics.recordError(text);
      else if( Platform.OS === 'android' ) Crashlytics.logException(text);
    } catch (e) {
      console.log("loggexception", e)
    } finally {

    }
  }
};

module.exports = AnalyticsManager;



// WEBPACK FOOTER //
// ./src/AnalyticsManager.js